export const IMPEDANCE = 'impedance',
  DELAY = 'delay',
  WAVEFORM = 'waveform',
  CHANNEL = 'channel',
  EYE_DIAGRAMS = 'eyeDiagrams',
  CAPACITANCE = 'capacitance';